import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  arrowAction: {
    width: theme.spacing(2.5),
    height: theme.spacing(4),
    color: theme.palette.textField.main,
    marginTop: theme.spacing(0.2),
    paddingLeft: theme.spacing(1.3),
    cursor: 'pointer',
  },
  cardContainer: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: theme.spacing(1),
    background: theme.palette.text.white,
    padding: theme.spacing(2.5, 3),
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    cursor: 'pointer',
  },
  cardContent: {
    padding: theme.spacing(3, 0, 0, 0),
  },
  dimensionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(4, 0),
    marginBottom: theme.spacing(10),
  },
  emptyState: {
    padding: theme.spacing(3),
    color: theme.palette.labraText.description,
  },
  tableContainer: {
    width: '100%',
  },
  fieldsToMapRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dimensionName: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  dimensionInfoIcon: {
    color: theme.palette.primary.main,
    flex: '0 0 auto',
    cursor: 'help',
  },
  fieldsToMap: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
    alignSelf: 'center',
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  hubspotFields: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  inputSelect: {
    background: theme.palette.text.white,
    height: 'fit-content',
    alignSelf: 'center',
    borderRadius: theme.spacing(0.5),
    width: '100%',
    minWidth: 0,
  },
  inputText: {
    height: 'fit-content',
    alignSelf: 'center',
    borderRadius: theme.spacing(0.5),
    width: '100%',
  },
}))
